import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import './Buttons.styl';

const Button = ({
    action,
    className,
    color,
    hasLightBorder,
    icon,
    iconToRight,
    isDisabled,
    isFilled,
    isSecondary,
    text,
    textColor,
}) => {
    const style = {};

    if (color !== null) {
        style.backgroundColor = color;
    }
    if (textColor !== null) {
        style.color = textColor;
    }
    const props = isDisabled ? {} : { onClick: action, onKeyPress: action };
    return (
        <div
            className={clsx('button', className, {
                hasLightBorder,
                isDisabled,
                isFilled,
                isSecondary,
            })}
            style={style}
            role='button'
            tabIndex='0'
            // onKeyPress={isDisabled ? () => {} : () => action()}
            // onClick={isDisabled ? () => {} : () => action()}
            {...props}
        >
            {icon !== null && !iconToRight && (
                <i className={`icon icon-${icon}`} />
            )}
            <span>{text}</span>
            {icon !== null && iconToRight && (
                <i className={`icon icon-${icon}`} />
            )}
        </div>
    );
};

Button.defaultProps = {
    className: '',
    color: null,
    hasLightBorder: false,
    icon: null,
    iconToRight: false,
    isDisabled: false,
    isFilled: false,
    isSecondary: false,
    textColor: null,
};

Button.propTypes = {
    action: PropTypes.func.isRequired,
    className: PropTypes.string,
    color: PropTypes.string,
    hasLightBorder: PropTypes.bool,
    icon: PropTypes.string,
    iconToRight: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isFilled: PropTypes.bool,
    isSecondary: PropTypes.bool,
    text: PropTypes.string.isRequired,
    textColor: PropTypes.string,
};

export default Button;
